var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"title":"适用商户","loading":_vm.loading}},[(!_vm.loading)?[_c('div',{class:_vm._.list},[_c('BookStore',{attrs:{"value":_vm.storeData,"show-address":true}})],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }